import { TwilioCalDetailsDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useGetTwilioCallDetails(
  twilioSsid: string,
  refetchInterval?: (data: TwilioCalDetailsDTO | undefined) => number | false
) {
  const url = `/v2/orm/voice/twilio/call_details/${twilioSsid}`;
  const request = new Request(url);

  return useAuthenticatedRequest<TwilioCalDetailsDTO>(request, {
    queryKey: ['twilio_call_details', twilioSsid],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    refetchInterval,
  });
}

export default useGetTwilioCallDetails;
